"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.importMetaEnv = void 0;
const importMetaEnv = exports.importMetaEnv = import.meta.env;